import { SEARCH_USERS, SEARCH_USERS_SUCCESS, SEARCH_USERS_FAILURE } from "../actionTypes";

export const searchUsers = (payload) => ({
  type: SEARCH_USERS,
  payload,
});

export const searchUsersSuccess = (payload) => ({
  type: SEARCH_USERS_SUCCESS,
  payload,
});

export const searchUsersFailure = () => ({
  type: SEARCH_USERS_FAILURE,
});
